class Planner {
    constructor(data) {
      this.id =  data.id || '';
      this.start_time = data.start_time || '';
      this.end_time = data.end_time || '';
      this.title = data.title || '';
      this.content = data.content || '';
      this.category_id = data.category_id || '';
      this.category = data.category 
      this.item_type = data.item_type || null;
    
    }
  
    static fromJson(json) {
      return new Planner({
        id: json.id,
        start_time: json.start_time,
        title: json.title,
        end_time: json.end_time,
        content: json.content,
        category_id: json.category_id,
        category: json.category,
        item_type: json.item_type,
       
      });
    }
  
    toJson() {
      return {
        id: this.id,
        start_time: this.start_time,
        title: this.title,
        end_time: this.end_time,
        content: this.content,
        category_id: this.category_id,
        category: this.category,
        item_type: this.item_type,
       
      };
    }
  
    get formattedStartTime() {
      return new Date(this.start_time);
    }
  
    get formattedEndTime() {
      return new Date(this.end_time);
    }
    
    
    
  
  }
  
  export default Planner; 